module.exports = __webpack_public_path__ + "img/p1.7ac89fc3.png";